import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=0d6bd6ff&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"
import style0 from "./editDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports